import { FC } from 'react';
import { CardContent } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@components/ui';
import { CardHeader } from '@components/ui/Card';
import { FORM_BUTTON_LABELS, LOG_IN_FORM_ID } from '@modules/auth/constants';

const ResetPasswordSuccess: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <CardHeader
        title={t('auth.reset_password.success_title')}
        subheaders={[
          <Trans
            key="auth.reset_password.success_subheader"
            i18nKey="auth.reset_password.success_subheader"
          />,
        ]}
      />
      <CardContent sx={styles.cardContent}>
        <Button
          sx={styles.button}
          type="submit"
          variant="contained"
          size="large"
          onClick={() => navigate('/auth/login')}>
          {FORM_BUTTON_LABELS[LOG_IN_FORM_ID] ?? 'Log In'}
        </Button>
      </CardContent>
    </>
  );
};
const styles = {
  button: { alignSelf: 'center', width: 'auto' },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
};

export { ResetPasswordSuccess };
